import React, { useState, useEffect, Component } from "react";
import { Route, Switch, Redirect, useHistory } from "react-router-dom";
import { Routes } from "../routes";

// pages
import DashboardOverview from "./dashboard/DashboardOverview";
import Transactions from "./Transactions";
import Settings from "./Settings";
import BootstrapTables from "./tables/BootstrapTables";
import Signin from "./components/Signin";
import Signup from "./components/Signup";
import ForgotId from "./components/ForgotId";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import EditProfile from "./components/EditProfile";
import Lock from "./components/Lock";
import NotFoundPage from "./components/NotFound";
import ServerError from "./components/ServerError";
import Admin from "./admin/Admin";
import Front from "./components/Front";

// components
import Footer from "../components/Footer";
import Preloader from "../components/Preloader";
import Confirm from "./components/Confirm";
import MiniNav from "../components/MiniNav";
import Search from "../components/Search";
import Home from "../components/Home";
import SearchResult from "../components/SearchResult";
import CompInfo from "./components/CompInfo";
import AttentionsInfo from "./components/AttentionsInfo";
import MatchingInfo from "./components/MatchingInfo";
import Sidebar from "../components/Sidebar";
import NewSidebar from "../components/NewSidebar";
import { authFetch, useAuth } from "../auth";
import AdminNav from "../components/AdminNav";
import AdminSide from "../components/AdminSide";
import UserManage from "./admin/UserManage";
import MatManage from "./admin/MatManage";
import CompManage from "./admin/CompManage";
import { AdminModal } from "../components/Modal";
import { SurveyModal } from "../components/Modal";

/*
{show && (
            <SurveyModal
              onCancel={() => {
                setShow((prev) => !prev);
              }}
            />
          )}{" "}
*/

const RouteWithLoader = ({ component: Component, ...rest }) => {
  const [loaded, setLoaded] = useState(false);
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Route
      {...rest}
      render={(props) => (
        <>
          <Preloader show={loaded ? false : true} /> <Component {...props} />{" "}
        </>
      )}
    />
  );
};

const RouteWithFront = ({ component: Component, ...rest }) => {
  const [loaded, setLoaded] = useState(false);
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Route
      {...rest}
      render={(props) => (
        <>
          <Preloader show={loaded ? false : true} /> <Component {...props} />{" "}
        </>
      )}
    />
  );
};

const RouteWithSurvey = ({ component: Component, ...rest }) => {
  const [loaded, setLoaded] = useState(false);
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Route
      {...rest}
      render={(props) => (
        <>
          {show && (
            <SurveyModal
              onCancel={() => {
                setShow((prev) => !prev);
              }}
            />
          )}{" "}
          <Preloader show={loaded ? false : true} /> <Component {...props} />{" "}
        </>
      )}
    />
  );
};

const RouteWithAdmin = ({ component: Component, ...rest }) => {
  const [loaded, setLoaded] = useState(false);
  const [logged] = useAuth();
  const history = useHistory();

  useEffect(() => {
    if (logged) {
      authFetch(process.env.REACT_APP_API_URL + "/api/admin").then((resp) => {
        console.log(resp.token);
        if (resp.status !== 200) {
          history.push(Routes.Home.path);
        }
      });
    } else {
      history.push(Routes.Signin.path);
    }
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, [history, logged]);

  return (
    <Route
      {...rest}
      render={(props) => (
        <>
          <Preloader show={loaded ? false : true} />
          <main className="position-relative">
            <AdminNav />

            <div className="content position-relative min-vh-100">
              <AdminSide />
              <Component {...props} />
            </div>
          </main>
          <Footer />
        </>
      )}
    />
  );
};

const RouteWithSidebar = ({ component: Component, ...rest }) => {
  const [loaded, setLoaded] = useState(false);
  const [logged] = useAuth();
  const history = useHistory();

  useEffect(() => {
    if (!logged) {
      history.push(Routes.Signin.path);
    }

    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, [history, logged]);

  return (
    <Route
      {...rest}
      render={(props) => (
        <>
          <Preloader show={loaded ? false : true} />
          <main className="position-relative">
            <MiniNav />

            <div className="content position-relative min-vh-100">
              <Search />
              <Sidebar />
              <Component {...props} />
            </div>
          </main>
          <Footer />
        </>
      )}
    />
  );
};

export default () => {
  const searchReasult = [];

  return (
    <Switch>
      {
        //<RouteWithSurvey exact path={Routes.Signin.path} component={Signin} />
      }
      <RouteWithLoader exact path={Routes.Signin.path} component={Signin} />
      <RouteWithLoader exact path={Routes.Signup.path} component={Signup} />
      <RouteWithLoader path={Routes.Confirm.path} component={Confirm} />
      <RouteWithLoader exact path={Routes.ForgotId.path} component={ForgotId} />
      <RouteWithLoader
        exact
        path={Routes.ForgotPassword.path}
        component={ForgotPassword}
      />
      <RouteWithLoader
        path={Routes.ResetPassword.path}
        component={ResetPassword}
      />
      <RouteWithLoader exact path={Routes.Lock.path} component={Lock} />
      <RouteWithLoader
        exact
        path={Routes.NotFound.path}
        component={NotFoundPage}
      />
      <RouteWithLoader
        exact
        path={Routes.ServerError.path}
        component={ServerError}
      />

      <RouteWithFront
        exact
        path={Routes.Front.path}
        component={Front}
      />

      <RouteWithFront
        exact
        path={Routes.Defalut.path}
        component={Front}
      />

      {/* pages */}
      <RouteWithSidebar
        exact
        path={Routes.Home.path}
        component={() => {
          return <Home searchList={searchReasult} />;
        }}
      />
      <RouteWithSidebar
        exact
        path={Routes.SearchResult.path}
        component={() => {
          return <SearchResult searchList={searchReasult} />;
        }}
      />
      <RouteWithSidebar
        exact
        path={Routes.EditProfile.path}
        component={EditProfile}
      />
      <RouteWithSidebar path={Routes.CompInfo.path} component={CompInfo} />
      <RouteWithSidebar
        path={Routes.AttentionsInfo.path}
        component={AttentionsInfo}
      />
      <RouteWithSidebar
        path={Routes.MatchingInfo.path}
        component={MatchingInfo}
      />
      <RouteWithSidebar path={Routes.Industry.path} component={Home} />
      <RouteWithAdmin exact path={Routes.Admin.path} component={Admin} />
      <RouteWithAdmin
        exact
        path={Routes.UserManage.path}
        component={UserManage}
      />
      <RouteWithAdmin
        exact
        path={Routes.MatManage.path}
        component={MatManage}
      />
      <RouteWithAdmin
        exact
        path={Routes.CompManage.path}
        component={CompManage}
      />
      <Redirect to={Routes.NotFound.path} />
    </Switch>
  );
};
